import styled from 'styled-components';

export const StyledContent = styled.div`
  margin-bottom: 1rem;
`;
